import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import type {EmailStats as EmailStatsFragment} from 'nutshell-graphql-types';

type Props = {
    emailStats: EmailStatsFragment | null | undefined;
};

export function EmailStatusHeaderContent(props: Props) {
    if (!props.emailStats) return null;

    return (
        <>
            {props.emailStats.description} &nbsp;
            {props.emailStats.descriptionLinkHtmlRef ? (
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='primary'
                    to={props.emailStats.descriptionLinkHtmlRef}
                >
                    View
                </Link>
            ) : undefined}
        </>
    );
}
